import { camelCase } from 'lodash'
import { backgroundColors } from './statsConstants.js'

export const getBackgroundColor = (backgroundName) => {
  const bgColor = camelCase(backgroundName)
  return backgroundColors.get(bgColor)
}
